export const formatDatePtBr = Intl.DateTimeFormat('pt-br', { dateStyle: 'short' }).format;

export const formatDateTimePtBr = Intl.DateTimeFormat('pt-br', { dateStyle: 'short', timeStyle: 'medium' }).format;
